import { getRoot, IStateTreeNode } from "mobx-state-tree";
import { IRootStore } from "../_root-store";

export const withRootStore = (self: IStateTreeNode) => ({
  views: {
    get _rootStore(): IRootStore {
      return getRoot<IRootStore>(self);
    },
  },
});
